import React from 'react';

export const CurrencyContext = React.createContext();

export const useCurrency = () => React.useContext(CurrencyContext);